<template>
    <b-col>
        <b-row>
            <h3 class="ml-3">Material-Merge</h3>
        </b-row>
        <b-row class="my-2">
            <b-col>
                <b-form-input v-model="request.materialDonor" placeholder="Opfer-Material-ID"></b-form-input>
            </b-col>
            <b-col>
                <b-form-input v-model="request.materialRecipient" placeholder="Ziel-Material-ID"></b-form-input>
            </b-col>
            <b-col class="col-2 ml-2 pl-1">
                <b-col/>
                <b-col class="p-0">
                    <b-button block size="md" @click="create()" variant="primary">mergen</b-button>
                </b-col>
                <b-col/>
            </b-col>
        </b-row>
        <b-row v-if="requestProcessing">
            <b-col><b class="float-right"> Material-Merge-Job wird erzeugt...</b></b-col>
        </b-row>
        <b-row  class="my-2 py-2">
            <b-table
                v-if="materialMergeJobs"
                :items="materialMergeJobs"
                :fields="fields"
            >
                <template v-slot:cell(state)="row">
                    <span v-if="row.item.state == 'created'">erstellt</span>
                    <span v-else-if="row.item.state == 'error'">Fehler</span>
                    <span v-else-if="row.item.state == 'finished'">fertig</span>
                    <span v-else>???</span>
                </template>

                <template v-slot:cell(materialDonorId)="row">
                    <b-button
                        block
                        variant="outline-secondary"
                        size="sm"
                        @click="openInNewTab(`material/${row.item.materialDonorId}/edit`)"
                        :disabled="!row.item.materialDonorId"
                    >
                        <b v-if="row.item.materialDonorId" style="font-family:'Lucida Console', monospace">{{row.item.materialDonorId}}</b>
                        <b v-else style="color:gray">gelöscht</b>
                    </b-button>
                </template>

                <template v-slot:cell(materialRecipientId)="row">
                    <b-button
                        block
                        variant="outline-secondary"
                        v-if="row.item.materialRecipientId"
                        size="sm"

                        @click="openInNewTab(`material/${row.item.materialRecipientId}/edit`)"
                    >
                        <b style="font-family:'Lucida Console', monospace">{{row.item.materialRecipientId}}</b>
                    </b-button>
                </template>

                <template v-slot:cell(userId)="row">
                    <span>{{users.find( user => user.id == row.item.userId ).name}}</span>
                </template>

                <template v-slot:cell(errorMessage)="row">
                    <b-button
                        v-if="row.item.errorMessage"
                        block size="sm"
                        :variant="determineVariant(row.item)"
                        @click="openErrorMessage(row.item)"
                    >
                        <b style="font-family:'Lucida Console', monospace">Fehler</b>
                    </b-button>
                    <b-button
                        v-else-if="'error' == row.item.state"
                        block disabled size="sm"
                        variant="secondary"
                    >
                        <b style="font-family:'Lucida Console', monospace">Fehler</b>
                    </b-button>
                </template>

            </b-table>
        </b-row>
        <b-modal
            v-model="modalError.state"
            size="md"
            centered
            dismissible
            title="Fehler"
        >
            {{modalError.message}}
        </b-modal>
    </b-col>
</template>
<script>
export default {
    name: "MaterialMergeJob",
    data() {
        return {
            materialMergeJobs: null,
            modalError: {
                state: false,
                message: "",
                show: function(msg, error = null) {
                    this.state = true;
                    this.message = msg;
                    if(error){
                        if(error.response.data.message && error.response.data.message != "") {
                            this.message += " Error: " + error.response.data.message;
                        }else{
                          this.message += " Error: " + error.response.data.exception;
                        }
                    }
                }
            },
            request: {
                materialDonor: null,
                materialRecipient: null
            },
            requestProcessing: false,
            fields: [
                //{ key: 'state', label: 'Zustand' },
                { key: 'materialDonorId', label: 'Opferartikel' },
                { key: 'materialRecipientId',label: 'Zielartikel' },
                { key: 'created_at', label: 'erstellt am',  formatter: function(s) { return (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '‒' } },
                { key: 'finished_at', label: 'abgeschlossen am',  formatter: function(s) { return (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '‒' } },
                { key: 'userId', label: 'Benutzer' },
                { key: 'errorMessage', label: 'Fehler' },
                //{ key: 'state', label: 'Status' },
                { key: 'actions', label: '' }
            ],
        }
    },
    methods: {
        determineVariant(job) {
            console.log("'error' == job.state ", 'error' == job.state );
            console.log(job);
            console.log(!job.state.finished_at);
            if('error' == job.state 
            && (!job.state.finished_at))
                return 'danger';
            return 'secondary';
        },
        create() {
            this.requestProcessing = true;
            axios.post('/materialmerge/create', this.request ).then( response => {
               this.request = { materialDonor: null, materialRecipient: null };
               this.getMaterialMergeJobs();
               this.requestProcessing = false;
            })
            .catch( error => {
                this.requestProcessing = false;
                this.modalError.show("Job konnte nicht erstellt werden.", error);
            });
        },
        openInNewTab(url) {
            var win = window.open(url, "_blank");
            win.focus();
        },
        getMaterialMergeJobs() {
            Promise.all([
                axios.get('/materialmerge/getamount/100'),
                axios.get('/materialmerge/getopen')
            ]).then( ([responseAmount, responseOpen]) => {
                this.materialMergeJobs = responseAmount.data;
                for(const x of responseOpen.data) {
                    if(!this.materialMergeJobs.find(y => x.id == y.id)){
                        this.materialMergeJobs.push(x);
                    }
                }
            });
        },
        openErrorMessage(job) {
            this.modalError.state = true;
            this.modalError.message = job.errorMessage;
        }

    },
    created() {
        axios.get('/user/get').then( response => this.users = response.data ).catch( error => this.modalError.show( "Benutzerdaten konnten nicht geladen werden", error) );
        this.getMaterialMergeJobs();
    }
}
</script>
